// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var CaretDown = function CaretDown(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M2.775 5.805l4.946 4.946a.394.394 0 00.557 0l4.946-4.946a.394.394 0 00-.278-.672H3.054a.394.394 0 00-.279.672z"
    }))
  );
};

export default CaretDown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/CaretDown.js
// module id = 987
// module chunks = 0